<template>
  <v-container
    fluid
    class="main-container">
    <div class="px-4">
      <v-row>
        <v-toolbar
          flat
          color="transparent">
          <v-spacer></v-spacer>
          <v-toolbar-title class="score-title pl-4 text-uppercase">Finance</v-toolbar-title>
          <v-btn
            class="pr-0"
            style="margin-right: -12px; margin-bottom: -8px"
            text
            to="finance2">
            Next
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
        </v-toolbar>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-card
            :rounded="false"
            class="pa-5"
            elevation="1"
            style="border: 1px solid #d3eff8">
            <v-card-title class="justify-space-between pa-0">
              <div class="section-title">+ Life Cycle</div>
              <div class="section-title-border"></div>
            </v-card-title>
            <table class="tbl contents">
              <thead>
                <tr style="height: 33px">
                  <th class="title-cell text-left">
                    <div style="height: 30px; line-height: 30px; border-bottom: 2px solid grey; padding-left: 10px !important; font-size: 14px; width: 90%">연도</div>
                  </th>
                  <th
                    class="text-center"
                    v-for="n in cellLength"
                    :key="n">
                    <div style="height: 30px; line-height: 30px; border-bottom: 1px solid grey; font-size: 14px">
                      {{ `'${(currentYear - 1 + n).toString().substr(2, 2)}` }}
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr class="exit-row">
                  <td class="text-center title-cell">
                    <div class="col-header"><span class="ml-3">Exit</span></div>
                  </td>
                  <td
                    :class="['text-center', exit[0][n - 1] ? 'event' : '']"
                    v-for="n in cellLength"
                    :key="n">
                    <div :class="[n === 1 ? 'start-row' : '', n === cellLength ? 'end-row' : '']">{{ exit[0][n - 1] }}</div>
                  </td>
                </tr>
                <tr style="height: 25px; line-height: 25px">
                  <td class="text-center title-cell main">
                    <div
                      class="bottom-border"
                      style="width: 85%">
                      (예상)月생활비
                    </div>
                  </td>
                  <td
                    :class="['text-center', exit[0][n - 1] ? 'event' : '', 'bottom-border']"
                    v-for="n in cellLength"
                    :key="n">
                    {{ exit[1][n - 1] }}
                  </td>
                </tr>
                <tr class="age-row">
                  <td
                    class="text-left title-cell main"
                    rowspan="2">
                    본인
                  </td>
                  <td
                    :class="['text-center', exit[0][n - 1] ? 'event' : '', 'main']"
                    v-for="n in cellLength"
                    :key="n">
                    {{ exit[2][n - 1] }}
                  </td>
                </tr>
                <tr style="height: 25px; line-height: 25px">
                  <td
                    :class="['text-center', exit[0][n - 1] ? 'event' : '']"
                    v-for="n in cellLength"
                    :key="n">
                    <img
                      v-if="exit[3][n - 1]"
                      height="25px"
                      :src="getImg(exit[3][n - 1])" />
                  </td>
                </tr>
                <tr style="height: 25px; line-height: 25px">
                  <td class="text-left title-cell">국민연금</td>
                  <td
                    :class="['text-center', exit[0][n - 1] ? 'event' : '']"
                    v-for="n in cellLength"
                    :key="n">
                    {{ exit[4][n - 1] }}
                  </td>
                </tr>
                <tr>
                  <td class="text-left title-cell">퇴직연금</td>
                  <td
                    :class="['text-center', exit[0][n - 1] ? 'event' : '']"
                    v-for="n in cellLength"
                    :key="n">
                    {{ exit[5][n - 1] }}
                  </td>
                </tr>
                <tr style="height: 25px; line-height: 25px">
                  <td class="text-left title-cell">
                    <div
                      class="bottom-border"
                      style="width: 85%; height: 25px">
                      개인연금
                    </div>
                  </td>
                  <td
                    :class="['text-center', exit[0][n - 1] ? 'event' : '', 'bottom-border']"
                    v-for="n in cellLength"
                    :key="n">
                    {{ exit[6][n - 1] }}
                  </td>
                </tr>
                <tr class="age-row">
                  <td
                    class="text-left title-cell"
                    rowspan="2">
                    배우자
                  </td>
                  <td
                    :class="['text-center', exit[0][n - 1] ? 'event' : '']"
                    v-for="n in cellLength"
                    :key="n">
                    {{ exit[7][n - 1] }}
                  </td>
                </tr>
                <tr style="height: 25px; line-height: 25px">
                  <td
                    :class="['text-center', exit[0][n - 1] ? 'event' : '']"
                    v-for="n in cellLength"
                    :key="n">
                    <img
                      v-if="exit[8][n - 1]"
                      height="25px"
                      :src="getImg(exit[8][n - 1])" />
                  </td>
                </tr>
                <tr style="height: 25px; line-height: 25px">
                  <td class="text-left title-cell">국민연금</td>
                  <td
                    :class="['text-center', exit[0][n - 1] ? 'event' : '']"
                    v-for="n in cellLength"
                    :key="n">
                    {{ exit[9][n - 1] }}
                  </td>
                </tr>
                <tr style="height: 25px; line-height: 25px">
                  <td class="text-left title-cell">퇴직연금</td>
                  <td
                    :class="['text-center', exit[0][n - 1] ? 'event' : '']"
                    v-for="n in cellLength"
                    :key="n">
                    {{ exit[10][n - 1] }}
                  </td>
                </tr>
                <tr style="height: 25px; line-height: 25px">
                  <td class="text-left title-cell">
                    <div
                      class="bottom-border"
                      style="width: 85%">
                      개인연금
                    </div>
                  </td>
                  <td
                    :class="['text-center', exit[0][n - 1] ? 'event' : '', 'bottom-border']"
                    v-for="n in cellLength"
                    :key="n">
                    {{ exit[11][n - 1] }}
                  </td>
                </tr>
                <tr style="height: 25px; line-height: 25px">
                  <td class="text-left title-cell">주택연금</td>
                  <td
                    :class="['text-center', exit[0][n - 1] ? 'event' : '']"
                    v-for="n in cellLength"
                    :key="n">
                    {{ exit[12][n - 1] }}
                  </td>
                </tr>
                <tr style="height: 25px; line-height: 25px">
                  <td class="text-left title-cell">근로소득</td>
                  <td
                    :class="['text-center', exit[0][n - 1] ? 'event' : '']"
                    v-for="n in cellLength"
                    :key="n">
                    {{ exit[13][n - 1] }}
                  </td>
                </tr>
                <tr style="height: 25px; line-height: 25px">
                  <td class="text-left title-cell">기타</td>
                  <td
                    :class="['text-center', exit[0][n - 1] ? 'event' : '']"
                    v-for="n in cellLength"
                    :key="n">
                    {{ exit[14][n - 1] }}
                  </td>
                </tr>
                <tr style="height: 25px; line-height: 25px">
                  <td class="text-left title-cell">
                    <div
                      class="bottom-border"
                      style="width: 85%">
                      합
                    </div>
                  </td>
                  <td
                    :class="['text-center', exit[0][n - 1] ? 'event' : '', 'bottom-border']"
                    v-for="n in cellLength"
                    :key="n">
                    {{ exit[15][n - 1] }}
                  </td>
                </tr>
                <tr style="height: 25px; line-height: 25px">
                  <td class="text-left title-cell">현금흐름</td>
                  <td
                    :class="['text-center', 'text-body-1', 'font-weight-black', exit[16][n - 1] < 0 ? 'minus' : '', 'bottom-border']"
                    rowspan="2"
                    v-for="n in cellLength"
                    :key="n">
                    {{ Math.round(exit[16][n - 1]) }}
                  </td>
                </tr>
                <tr style="height: 25px; line-height: 25px">
                  <td class="text-left title-cell">
                    <div
                      class="bottom-border"
                      style="width: 85%">
                      (소득-생활비)
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-card
            :rounded="false"
            class="pa-5"
            elevation="1"
            style="border: 1px solid #d3eff8">
            <v-card-title class="justify-space-between pa-0">
              <div class="section-title">+ Cash Flow</div>
              <div class="section-title-border"></div>
            </v-card-title>
            <v-chart
              :options="opt"
              autoresize
              ref="chart"></v-chart>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import _ from 'lodash'
import Vue from 'vue'
import ECharts from 'vue-echarts'
import 'echarts/lib/chart/line'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/title'
import 'echarts/lib/component/dataset'
import 'echarts/lib/component/visualMap'
import echarts from 'echarts/lib/echarts'
import { mapMutations, mapState, mapGetters } from 'vuex'
export default {
  components: {
    'v-chart': ECharts,
  },
  mounted() {
    const expectedSalary = Number(this.finance['재무-기대근로소득'].value[0].value)
    this.drawChart(
      this.exit[16].map((k) => Number(k)),
      expectedSalary
    )
    // console.log(this.housePension)
  },
  data() {
    return {
      icon: {
        Finance: 'mdi-finance',
        Master: 'mdi-telegram',
        Career: 'mdi-briefcase',
        Life: 'mdi-home-city-outline',
      },
      관계: 'mdi-handshake',
      커리어: 'mdi-briefcase',
      건강: 'mdi-hospital-box',
      재무: 'mdi-cash-usd-outline',
      opt: {
        grid: {
          width: '100%',
          left: '5%',
          hegith: '70%',
        },
      },
    }
  },
  computed: {
    ...mapState(['master', 'me', 'wife', 'children', 'parents', 'finance', 'currentYear', 'housePension']),
    ...mapGetters(['getExit', 'getFinanceGoalMoney', 'exit']),
    cellLength() {
      const nintyAt = this.me.birthAt + 91
      // console.log(nintyAt, this.currentYear)
      return nintyAt - this.currentYear
      // return 40
    },
    crevasseAge() {
      const t = (this.exit[17] || []).slice(0)

      if (!t[0]) return '없음'
      else {
        const s = t.shift()
        const e = t.pop()

        if (!e) return '없음'
        else return s + '세부터 ' + e + '세까지'
      }
    },
    getInsurance() {
      const k = ((this.finance['재무-리스크'] || {}).value || []).filter((o) => !o.value)
      if (k.length === 0) return '없음'
      else return k.map((o) => o.text.split(/\s/g)[0]).join(',')
    },
    getSourcingMoney() {
      const t = _.orderBy(this.finance['재무-목적자금-우선순위'].list, ['order'], ['asc'])

      const e1 = t.shift().title
      const e2 = t.shift().title

      const k = this.finance['재무-목적자금-계획'].value

      const ep1 = Number(k.filter((o) => o.title === e1)[0].value[1]) + this.me.birthAt
      const ep2 = Number(k.filter((o) => o.title === e2)[0].value[1]) + this.me.birthAt

      return [
        [e1, ep1],
        [e2, ep2],
      ]
    },
  },
  methods: {
    getImg(event) {
      if (event === '정년') return '/images/retire.svg'
      if (event === '연금') return '/images/pension.svg'
      if (event === '결혼') return '/images/marry.svg'
      if (event === '상배') return '/images/solo.svg'
      if (event === '근속') return '/images/work.svg'
      if (event === '임피') return '/images/salary.svg'
      if (event === '취직') return '/images/job.svg'
      if (event === '가료') return '/images/care.svg'
    },
    drawChart(data, expectedSalary) {
      console.log('-->', data, expectedSalary)
      const boundary = []
      data.forEach((o, i) => {
        if (o < 0) boundary.push(i)
      })
      let p = [
        {
          gt: (boundary[0] || 0) < 0 ? 0 : boundary[0],
          lt: boundary.pop() || 0,
          // color: 'rgba(112, 202, 233, 0.9)',
          // color: '#6ac9ec',
          color: '#F37C84',
        },
      ]
      if (boundary.length === 0) p = []
      const eventIdx = this.exit[0].indexOf('퇴직')

      const empLabel = `퇴직후 근로소득 (${expectedSalary}만원) 발생시`
      const option = {
        legend: {
          data: [{ name: '퇴직후 근로소득 미발생시' }, { name: empLabel }],
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: [...new Array(this.cellLength).keys(), 1, 1].map((i) => {
            const yy = (i + this.currentYear).toString()
            return `'${yy.substr(2, 2)}`
          }),
        },
        yAxis: {
          type: 'value',
          name: '현금흐름[백만원]',
        },
        visualMap: {
          type: 'piecewise',
          show: false,
          dimension: 0,
          seriesIndex: 0,
          pieces: p,
        },
        series: [
          {
            name: '퇴직후 근로소득 미발생시',
            type: 'line',
            smooth: 0.2,
            symbol: 'none',
            lineStyle: {
              color: 'red',
              // color: 'rgb(112, 202, 233)',
              width: 3,
            },
            markLine: {
              symbol: ['none', 'none'],
              label: { show: false },
              data: [{ xAxis: 1 }, { xAxis: 3 }, { xAxis: 5 }, { xAxis: 7 }],
            },
            areaStyle: {},
            data: data,
          },
          {
            name: empLabel,
            type: 'line',
            smooth: 0.2,
            symbol: 'none',
            lineStyle: {
              color: 'blue',
              // color: 'rgb(112, 202, 233)',
              width: 2,
            },
            // markLine: {
            //   symbol: ['none', 'none'],
            //   label: { show: false },
            //   data: [{ xAxis: 1 }, { xAxis: 3 }, { xAxis: 5 }, { xAxis: 7 }],
            // },
            data: data.map((k, i) => {
              if (i > eventIdx) return k + expectedSalary
              else return k
            }),
          },
        ],
        // xAxis: {
        //   type: 'category',
        //   data: [...new Array(22).keys()].map((i) => i + this.currentYear),
        // },
        // yAxis: {
        //   type: 'value',
        // },
        // series: [
        //   {
        //     data: data,
        //     type: 'line',
        //     smooth: true,
        //   },
        // ],
      }
      console.log('-->', option)

      // opt.series[0].data = data
      this.$refs.chart.mergeOptions(option)
    },
    getExample() {
      // this.setExample()
    },
  },
}
</script>

<style
  scoped
  lang="scss">
table.contents {
  width: 100%;
}
.bottom-border {
  border-bottom: 1px solid grey;
}
table.tbl {
  border-collapse: collapse !important;
  table-layout: fixed;
  font-size: 12px;
  td {
    font-style: italic;
  }

  thead tr {
    height: 30px;
    font-weight: bold;
    font-size: 18px;
  }
  tr:nth-of-type(2n) {
    // background: #f7cac9;
  }
  tr.age-row > td {
    font-size: 16px !important;
    font-weight: 600;
    font-family: 'SamsungSans';
    font-style: initial;
    height: 25px;
    line-height: 25px;
  }
  div.content-cell {
    line-height: 25px;
    background: #70cae9;

    color: white;
    width: 100%;
    height: 25px;
  }
  div.content-border {
    border-radius: 25px 25px 25px 25px;
  }

  div.pension-start {
    border-radius: 5px 45% 45% 5px;
  }
  td div.start-row {
    border-top-left-radius: 25px;
    border-bottom-left-radius: 25px;
  }
  td div.end-row {
    border-top-right-radius: 25px;
    border-bottom-right-radius: 25px;
  }
  tr.exit-row {
    height: 20px;
    font-size: 12px;
    font-weight: 600;

    td div {
      line-height: 20px;
      background: grey;
      color: white;
      width: 100%;
      height: 20px;
    }

    div.col-header {
      text-align: left;
      width: 90%;
      border-radius: 0 25px 25px 0;
      background: grey;
      color: white;
    }
  }
  th,
  td :not(.title-cell) {
    white-space: nowrap;
    word-break: break-all;

    // border: 1px solid grey;
  }
  td.title-cell {
    overflow-wrap: break-word;
  }
  th.event,
  td.event {
    // border-left: 2px solid #9b1b30; //#9b1b30;
    // font-weight: 600;
    // color: white; #2a4b7c; //
    background-color: rgba(42, 75, 124, 0.3) !important;
    div {
      background-color: rgba(42, 75, 124, 0.6) !important;
    }
  }

  .title-cell {
    min-width: 90px !important;
    // width: 4%;
    width: 95px;

    // background-color: #2a4b7c;
    // color: white;
  }
  td.minus {
    font-weight: 600;
    color: #9b1b30;
  }
}
.score {
  padding: 18px;
}
.life-top {
  font-size: 1em;
  border-bottom: 2px solid black;
}
.header-col {
  border-right: 1px solid black;
}
.life {
  text-align: center;
  min-height: 64px;
}
.life-footer {
}
// .echarts {
//   width: 100%;
//   height: 100%;
// }
.echarts {
  height: 300px;
  width: 100%;
}
.good {
  display: flex;
  flex-direction: column;
  justify-content: center;
  border-right: 1px solid grey;
}
.bad {
  display: flex;
  flex-direction: column;
  justify-content: center;
  border-right: 1px solid grey;
}
.happy-row {
  border-top: 1px solid grey;
}
</style>
